import { render } from "./AnnotationInstanceView.vue?vue&type=template&id=6c3f9974&scoped=true"
import script from "./AnnotationInstanceView.vue?vue&type=script&lang=js"
export * from "./AnnotationInstanceView.vue?vue&type=script&lang=js"

import "./AnnotationInstanceView.vue?vue&type=style&index=0&id=6c3f9974&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3f9974"]])

export default __exports__